import React, { useEffect } from "react";
import Ai from "../../../Images/ItservicesImg-removebg-preview.png";
import ScrollMagic from "scrollmagic";

const Itservices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const controller = new ScrollMagic.Controller();

    const triggerElement = document.getElementById("triggerPinned");

    if (window.innerWidth > 768 && triggerElement) {
      new ScrollMagic.Scene({
        triggerElement: triggerElement,
        triggerHook: 0,
      })
        .setPin(triggerElement)
        .addTo(controller);
    }

    return () => controller.destroy();
  }, []);

  const itServices = [
    {
      title: "Managed IT Services",
      description: "Proactive monitoring, maintenance, and support for uninterrupted operations.",
    },
    {
      title: "Network Infrastructure Setup",
      description:
        "Design, implement, and optimize networks to ensure speed, stability, and security.",
    },
    {
      title: "Cybersecurity Solutions",
      description:
        "Protect your business from threats with advanced security protocols and monitoring.",
    },
    {
      title: "Cloud Services & Migration",
      description: "Seamlessly move to the cloud and manage your digital workspace effectively.",
    },
    {
      title: "End-User Support",
      description: "Helpdesk and tech support that keeps your teams productive.",
    },
    {
      title: "Software & System Maintenance",
      description: "Ensure applications run smoothly with regular updates and performance tuning.",
    },
  ];

  return (
    <div>
      <div>
        <div className="banner-generative" id="triggerPinned">
          <h1>Empowering Digital Transformation with Expert IT Support</h1>
        </div>
        <div className="white-section">
          <div className="about-generative-ai">
            <div className="left-content-ai">
              <h1>Reliable. Scalable. Future-Ready Technology Solutions</h1>
              <p>
                At Owision, we deliver comprehensive IT services that help businesses scale faster,
                operate smarter, and stay ahead in a digital-first world. Whether you’re looking to
                modernize infrastructure, enhance cybersecurity, or outsource tech support, our
                solutions are designed to be efficient, secure, and customized to your goals.
              </p>
            </div>
            <div className="right-content-ai">
              <img src={Ai} alt="ai image" />
            </div>
          </div>
          <div className="generative-card-caontainer">
            <h1> Our Generative AI Capabilities</h1>
            <div className="generative-card-list">
              {itServices.map((service, index) => (
                <div className="generative-card" key={index}>
                  <h2>{service.title}</h2>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Itservices;
